import sendRequest from './send-request';
const BASIC_URL = process.env.REACT_APP_BASIC_URL;
const BASE_URL = `${BASIC_URL}/api/listings`;
const STAT_URL = `${BASIC_URL}/api/stats`


export function getAll() {
  return sendRequest(BASE_URL, 'GET');
}

export function getAvailableCount(){
    console.log('Counting Available listings')
   return sendRequest(`${BASE_URL}/countAvailable`, 'GET');
}

export function getShortAvailableListings(){
  console.log('Geting Summary of Available listings')
   return sendRequest(`${BASE_URL}/shortAvailable`, 'GET');
}

export function getShortAllListings(){
  console.log('Geting Summary of ALL listings')
   return sendRequest(`${BASE_URL}/shortAll`, 'GET');
}

export function deleteListing(listingData){
  return sendRequest(`${BASE_URL}/:id`, 'DELETE',listingData)
}

export function create(listingData){
  return sendRequest(`${BASE_URL}/new`, 'POST', listingData)
}

export function getById(id) {
  console.log("Got this listing id passed", id)
  return sendRequest(`${BASE_URL}/${id}`,'GET');
}

export function update(listingData, id) {
  // console.log("in listings-api");
  // console.log(listingData, id);
  return sendRequest(`${BASE_URL}/${id}`,'PUT', listingData);
}





export function addStat(stat){
  return sendRequest(`${STAT_URL}/new`, 'PUT', stat)
}

export function getStats(){
  return sendRequest(`${STAT_URL}/read`, 'GET');
}

export function removeStat(){
  return sendRequest(`${STAT_URL}/adm`, 'PUT')
}

// export function updateStats(stat, id){
//   return sendRequest(`${BASE_URL}/${id}`,'PUT', stat);
// }